import { DATASOURCE, FIELD_TYPE } from 'schemas/types';
import { Plugin } from 'plugins/types';
import S1ActionsButton from './actions/sentinel-one/ActionsButton';
import S1ToolbarActionsButton from './actions/sentinel-one/ToolbarActionsButton';
import {
  DataSourceCellRenderer,
  EndpointCellRenderer,
  EventDetailsCellRenderer,
  EventSourceCellRenderer,
  EventTargetCellRenderer,
  EventTypeCellRenderer,
  FileCellRenderer,
  ProcessCellRenderer,
  TextCellRenderer,
  TimestampCellRenderer,
} from './cell-renderers';
import {
  DataSourceFieldRenderer,
  DeviceFieldRenderer,
  DnsFieldRenderer,
  EndpointFieldRenderer,
  EventTypeFieldRenderer,
  FileFieldRenderer,
  GenericFieldRenderer,
  IPAddressFieldRenderer,
  ModuleFieldRenderer,
  ProcessFieldRenderer,
  RegistryKeyFieldRenderer,
  TaskFieldRenderer,
  TimestampFieldRenderer,
  UrlFieldRenderer,
  UserFieldRenderer,
} from './field-renderers';
import { DVLogDetailsRenderer } from './log-details-renderers';
import { DVEndpointDetailsRenderer } from './endpoint-details/DVEndpointDetailsRenderer';
import EndpointDataManager from './actions/sentinel-one/EndpointDataManager';
import { CreateStarRuleMenuItem } from './actions/sentinel-one/CreateSTARRuleButton';

import './styles.scss';

export const plugin: Plugin = {
  name: 'deep-visibility',
  actionsButtons: {
    [DATASOURCE.SENTINEL_ONE]: S1ActionsButton,
  },
  cellRenderers: {
    [FIELD_TYPE.DATA_SOURCE]: DataSourceCellRenderer,
    [FIELD_TYPE.ENDPOINT]: EndpointCellRenderer,
    [FIELD_TYPE.EVENT_DETAILS]: EventDetailsCellRenderer,
    [FIELD_TYPE.EVENT_SOURCE]: EventSourceCellRenderer,
    [FIELD_TYPE.EVENT_TARGET]: EventTargetCellRenderer,
    [FIELD_TYPE.EVENT_TYPE]: EventTypeCellRenderer,
    [FIELD_TYPE.FILE]: FileCellRenderer,
    [FIELD_TYPE.PROCESS]: ProcessCellRenderer,
    [FIELD_TYPE.TEXT]: TextCellRenderer,
    [FIELD_TYPE.TIMESTAMP]: TimestampCellRenderer,
  },
  fieldRenderers: {
    [FIELD_TYPE.DATA_SOURCE]: DataSourceFieldRenderer,
    [FIELD_TYPE.DEVICE]: DeviceFieldRenderer,
    [FIELD_TYPE.DNS]: DnsFieldRenderer,
    [FIELD_TYPE.ENDPOINT]: EndpointFieldRenderer,
    [FIELD_TYPE.EVENT_TYPE]: EventTypeFieldRenderer,
    [FIELD_TYPE.FILE]: FileFieldRenderer,
    [FIELD_TYPE.IP_ADDRESS]: IPAddressFieldRenderer,
    [FIELD_TYPE.MODULE]: ModuleFieldRenderer,
    [FIELD_TYPE.PROCESS]: ProcessFieldRenderer,
    [FIELD_TYPE.REGISTRY_KEY]: RegistryKeyFieldRenderer,
    [FIELD_TYPE.TASK]: TaskFieldRenderer,
    [FIELD_TYPE.TEXT]: GenericFieldRenderer,
    [FIELD_TYPE.TIMESTAMP]: TimestampFieldRenderer,
    [FIELD_TYPE.URL]: UrlFieldRenderer,
    [FIELD_TYPE.USER]: UserFieldRenderer,
  },
  inspectDrawerRenderer: DVLogDetailsRenderer,
  supportedProductIds: ['xdr', 'edr'],
  toolbarComponents: {
    [DATASOURCE.SENTINEL_ONE]: S1ToolbarActionsButton,
  },
  cellDataDetailsCardRenderers: {
    [FIELD_TYPE.ENDPOINT]: DVEndpointDetailsRenderer,
  },
  detailsDataManager: {
    [DATASOURCE.SENTINEL_ONE]: EndpointDataManager,
  },
  searchResultsMenuItems: [CreateStarRuleMenuItem],
};
